import { render, staticRenderFns } from "./Trustedips.vue?vue&type=template&id=457c826e&"
import script from "./Trustedips.vue?vue&type=script&lang=js&"
export * from "./Trustedips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports